// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2J3N9","title":"Header_title__32itd","left":"Header_left__LQCzQ","clinicName":"Header_clinicName__25eLW"};